<template>
  <div class="error-page">
    <div class="error-img">
      <img src="../assets/images/error-404.png" alt />
    </div>
    <div class="error-result">对不起，您访问的页面不存在...</div>
    <div class="error-btn">
      <Button type="primary" :to="{name:'Home'}">返回首页</Button>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../utils/mixin";
export default {
  mixins: [siteMixin],
  mounted() {
    this.setMetaData("页面不存在");
  },
};
</script>
<style lang="less" scoped>
.error-page {
  margin-top: 50px;
  .error-img {
    width: 255px;
    height: 295px;
    margin: 0 auto;
  }
  .error-result {
    margin-top: 3rem;
    font-size: 1.6rem;
    text-align: center;
    color: #666;
  }
  .error-btn {
    margin-top: 3rem;
    text-align: center;
  }
}
</style>